module.exports = __webpack_public_path__ + "img/icon_qiye03.c4d7c1bc.png";